
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/tour",
      function () {
        return require("private-next-pages/explore/tour.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/tour"])
      });
    }
  